/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_onboarding_connect_bloque_hint = /** @type {(inputs: {}) => string} */ () => {
	return `Funciona con Cursor, Windsurf, Claude Code y cualquier agente de IA.`
};

const en_onboarding_connect_bloque_hint = /** @type {(inputs: {}) => string} */ () => {
	return `Works with Cursor, Windsurf, Claude Code and any AI agent.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const onboarding_connect_bloque_hint = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.onboarding_connect_bloque_hint(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("onboarding_connect_bloque_hint", locale)
	if (locale === "es") return es_onboarding_connect_bloque_hint(inputs)
	return en_onboarding_connect_bloque_hint(inputs)
};
export { onboarding_connect_bloque_hint as "onboarding.connect_bloque.hint" }